import React from 'react';
import EmailSender from '../components/EmailSender';

const EmailSenderPage: React.FC = () => <EmailSender />;

export default EmailSenderPage;
